function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5 4h-19A1.504 1.504 0 0 0 1 5.5v13A1.5 1.5 0 0 0 2.5 20h19a1.5 1.5 0 0 0 1.5-1.5v-13A1.504 1.504 0 0 0 21.5 4zM12 12.07L2.82 5h18.36zm-2.846-.93L2 18.292V5.631zm.798.615L12 13.33l2.048-1.576L21.293 19H2.707zm4.894-.616L22 5.631v12.662z",
  fill: "white"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/envelope.9057873e.svg";
export { SvgComponent as ReactComponent };